import { Route, Routes } from 'react-router-dom';

import ArtistListPage from './Categories/ArtistListPage';
import CategoriesListPage from './Categories/CategoriesListPage';
import ContactListPage from './Contact/ContactListPage';
import KeywordListPage from './Keyword/KeywordListPage';
import LoginPage from './Login/LoginPage';
import OrderCreatePage from './Order/CreateOrderPage';
import OrderDetailPage from './Order/OrderDetailPage';
import OrderListPage from './Order/OrderListPage';
import ProductDetailPage from './Product/ProductDetailPage';
import ProductListPage from './Product/ProductListPage';
import UserDetailPage from './Users/UserDetailPage';
import UserListPage from './Users/UserListPage';
import UserPendingListPage from './Users/UserPendingList';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/users" element={<UserListPage />} />
      <Route path="/users/:userId" element={<UserDetailPage />} />
      <Route path="/contacts" element={<ContactListPage />} />
      <Route path="/keywords" element={<KeywordListPage />} />
      <Route path="/pending-approval" element={<UserPendingListPage />} />
      <Route path="/categories" element={<CategoriesListPage />} />
      <Route path="/artist" element={<ArtistListPage />} />
      <Route path="/orders" element={<OrderListPage />} />
      <Route path="/orders/create" element={<OrderCreatePage />} />
      <Route path="/orders/:orderId" element={<OrderDetailPage />} />
      <Route path="/products" element={<ProductListPage />} />
      <Route path="/product/:productId" element={<ProductDetailPage />} />
      <Route path="/product/create" element={<ProductDetailPage />} />
    </Routes>
  );
};

export default Router;
